// eslint-disable-next-line import/prefer-default-export
export const IMAGE_TYPE = {
  extimg: "extimg",
  img: "img",
};
